module.exports = __webpack_public_path__ + "static/index/img/baikal-701.d10a0eea.jpg";